module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"custom_range":"カスタム範囲","compare_period":"比較期間","compare_with":"比較日","previous_period":"前期間"}}')
  delete Component.options._Ctor
}
